export default __webpack_public_path__ + "static/media/algorithms.93136980.webp";